import '../vendors/fontawesome-free-5.1.0/scss/fa-regular.scss';
import '../vendors/fontawesome-free-5.1.0/scss/fa-solid.scss';
import '../vendors/fontawesome-free-5.1.0/scss/fa-brands.scss';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
import '../scss/main.scss';
import '../vendor/twbs/bootstrap/dist/js/bootstrap';

import './advancedSearch';
import $ from 'jquery';
import {createRoot} from 'react-dom/client';
import {api} from './api/api';
import App from './admin/react-instance';
import SortByField from './components/sortByField/SortByField';
import {subscribe, waitForElements} from '@media-store-net/custom-events';

$( document ).ready( function ( w ) {
	const hardfacts = w( '.hardfacts' );

	function setIcons( DomElement ) {
		var icons = {
			Kaufpreis: '<i class="flaticon-148-money-icons"></i>',
			Kaltmiete: '<i class="flaticon-052-savings"></i>',
			Warmmiete: '<i class="flaticon-052-savings"></i>',
			Pacht: '<i class="flaticon-148-money-icons"></i>',
			Nebenkosten: '<i class="flaticon-134-plumbering-1"></i>',
			Wohnfläche: '<i class="flaticon-053-interior-design"></i>',
			Nutzfläche: '<i class="flaticon-088-cleaned"></i>',
			Grundstücksfläche: '<i class="flaticon-095-measuring"></i>',
			Grundstückfläche: '<i class="flaticon-095-measuring"></i>',
			Gewerbefläche: '<i class="flaticon-044-industrial-park"></i>',
			Lagerfläche: '<i class="flaticon-017-plans"></i>',
			Bürofläche: '<i class="flaticon-007-property"></i>',
			Kellerfläche: '<i class="flaticon-093-packaging"></i>',
			Gastraumfläche: '<i class="flaticon-017-plans"></i>',
			Gesamtfläche: '<i class="flaticon-016-houses"></i>',
			'Anzahl Zimmer': '<i class="flaticon-117-beds"></i>',
			'Anzahl Gewerbeeinheiten':
				'<i class="flaticon-044-industrial-park"></i>',
			'Anzahl Wohneinheiten': '<i class="flaticon-050-fireplace-1"></i>',
		};

		w.each( DomElement, function ( i, v ) {
			const label = w( v.children[ 1 ] ).html().trim();
			const elem = w( this );

			if ( icons.hasOwnProperty( label ) ) {
				elem.prepend( icons[ label ] );
			}
		} );
	}

	if ( w( '#image-carousel' ).length ) {
		const slider = w( '#image-carousel' ).carousel( { interval: 5000 } );
	}

	/**
	 * @description function to expand the Content Area in OnePage Template to full height
	 */
	if ( w( '#single-more-button' ).length ) {
		( function () {
			var elementHeight = w( '#beschreibung' ).css( 'height' );

			w( '#single-more-button' ).click( function () {
				return ( this.tog = ! this.tog )
					? ( function () {
							w( '#beschreibung' ).css( {
								height: 'auto',
								transition: 'height 2s',
							} );
					  } )()
					: ( function () {
							w( '#beschreibung' ).css( 'height', elementHeight );
					  } )();
			} );
		} )();
	}

	/**
	 * @description add pagination class to .page-numbers
	 */
	if ( w( '.page-numbers' ).length ) {
		w( '.page-numbers' ).addClass( 'pagination' );
	}

	if ( w( '.single-wpi_immobilie' ) && w( hardfacts ).length ) {
		setIcons( hardfacts );
	}
	// Filter the h3 text on Content
	if ( w( '#dreizeiler h3' ).length ) {
		w( '#dreizeiler h3' ).html( 'Kurzbeschreibung' );
	}
	if ( w( '#ausstatt_beschr h3' ).length ) {
		w( '#ausstatt_beschr h3' ).html( 'Ausstattung' );
	}
	if ( w( '#sonstige_angaben h3' ).length ) {
		w( '#sonstige_angaben h3' ).html( 'Sonstiges' );
	}
	if ( w( '#user_defined_simplefield h3' ).length ) {
		w( '#user_defined_simplefield h3' ).html( 'Weitere Angaben' );
	}
} );

const renderSortByField = () => {
	waitForElements( '.sort-by-field' ).then( function ( elements ) {
		if ( elements.length ) {
			for ( const element of elements ) {
				const label = element.dataset.label;
				const options = element.dataset.options
					? JSON.parse( element.dataset.options )
					: [];

				createRoot( element, {} ).render(
					<App
						Component={ SortByField }
						pageProps={ { label, options } }
					/>
				);
			}
		}
	} );
};
renderSortByField();

const reloadPropertiesOnSort = () => {
	subscribe( 'sortByFieldChanged', ( { detail } ) => {
		const { fieldRef, selectedValue } = detail;
		const targetQuery = $( fieldRef )
			.closest( '.content-div' )
			.data( 'queryvars' );
		const selectedQuery = selectedValue.split( '_' );
		if ( Array.isArray( selectedQuery ) ) {
			targetQuery.orderby = selectedQuery[ 0 ];
			targetQuery.order = selectedQuery[ 1 ];
		}
		const contentReplacementNode = $( fieldRef )
			.closest( '.content-div' )
			.find( '#wpi-main' );

		api.search.ajaxSearch( { ...targetQuery } ).then( ( response ) => {
			contentReplacementNode.html( response );
		} );
	} );
};
reloadPropertiesOnSort();
